import React from 'react'
import { string } from 'prop-types'
import { TERMS_AND_CONDITIONS_URL, PRIVACY_POLICY_URL } from '../../../helpers/constants'
import { insertValuesInTranslation } from '../../../helpers/string-helpers'

const TermsAndConditions = ({ customTermsAndConditions, companyName }) => {
  const legalText = insertValuesInTranslation(window.NFT.I18n.single_info_request.terms_and_conditions_message, {
    company: companyName,
    termsUrl: TERMS_AND_CONDITIONS_URL,
    privacyUrl: PRIVACY_POLICY_URL
  })

  return <p className='nft-terms-conditions' dangerouslySetInnerHTML={{__html: customTermsAndConditions || legalText }}></p>
}

TermsAndConditions.propTypes = {
  companyName: string,
  customTermsAndConditions: string
}

export default TermsAndConditions
